__turbopack_context__.v({
  "container": "XFeed-module-scss-module__LyhDfa__container",
  "decorativeLabel": "XFeed-module-scss-module__LyhDfa__decorativeLabel",
  "feedPanel": "XFeed-module-scss-module__LyhDfa__feedPanel",
  "feedPanelWrapper": "XFeed-module-scss-module__LyhDfa__feedPanelWrapper",
  "panelTitle": "XFeed-module-scss-module__LyhDfa__panelTitle",
  "section": "XFeed-module-scss-module__LyhDfa__section",
  "tweetCard": "XFeed-module-scss-module__LyhDfa__tweetCard",
});
